"use strict";

import $ from "jquery";
import scrollToElm from "../../Shared/helpers/helper.scrollToElm";

export default function overview(scope) {
    $(scope).each(function () {
        const overviewBlock = $(this);
        const overviewToggle = overviewBlock.find(scope + "-toggle");
        const overviewList = overviewBlock.find(scope + "-list");

        // Add links to modules

        $("[data-anchor-name]").each(function () {
            const module = $(this);
            if (module.data("anchorName") === "") return;
            const linkToModule = `<a class="header__overview-list-item" href="#${module.attr("id")}">${module.data("anchorName")}</a>`;
            overviewList.append(linkToModule);
        });

        if (overviewList.children().length === 0) {
            $(".js-overview-toggle").remove();
        }

        // Toggle overview

        overviewToggle.on("click", function () {
            overviewBlock.toggleClass("active");
        });

        $(window).on("click", function (e) {
            if (overviewBlock.find(e.target).length === 0) {
                overviewBlock.removeClass("active");
            }
        });

        // Scroll to module

        overviewList.on("click", "a", function (e) {
            e.preventDefault();

            const target = $(this).attr("href");

            if (target.indexOf("#") === 0 && $(target).length !== 0) {
                scrollToElm(target, 500);

                if (history) {
                    history.pushState(null, null, target);
                }
            }

            overviewBlock.removeClass("active");
        });
    });
}
